<ion-header class="ion-no-border">

	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button (click)="close()">
				<fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
		<ion-title *ngIf="event">
			{{event.title}}
			<p class="subtitle">Sessions</p>
		</ion-title>
	</ion-toolbar>

</ion-header>

<ion-content>

	<ion-list *ngIf="sessions && sessions.length != 0">
		<ion-item *ngFor="let session of sessions" detail="true" button="true" lines="full" (click)="presentSelectSessionTicketTypeModal(event, session)">
			<ion-label>
                <h3>
                    <span *ngIf="session.title">{{session.title}}</span>
                    <span *ngIf="!session.title">{{event.title}}</span>
                </h3>
                <ion-grid class="ion-no-padding">
                    <ion-row *ngIf="session.start_date || session.end_date || session.venue">
                        <ion-col *ngIf="session.start_date" class="ion-text-nowrap" size="auto">
                            <h5>Start date</h5>
                            <p class="prominent">{{this.moment.utc(session.start_date).tz(session.timezone.code).format("D MMM YYYY, HH:mm")}}</p>
                        </ion-col>
                        <ion-col *ngIf="session.end_date" class="ion-text-nowrap" size="auto">
                            <h5>End date</h5>
                            <p class="prominent">{{this.moment.utc(session.end_date).tz(session.timezone.code).format("D MMM YYYY, HH:mm")}}</p>
                        </ion-col>
                        <ion-col *ngIf="session.venue && (session.venue.name || session.venue.address?.locality)" size="auto">
                            <h5>Venue</h5>
                            <p class="prominent">
                                <span *ngIf="session.venue.name">{{session.venue.name}}</span>
                                <span *ngIf="!session.venue.name">{{session.venue.address.locality}}</span>
                            </p>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col size="auto">
                            <h5>Tickets sold</h5>
                            <p class="prominent">{{session.ticket_count}}</p>
                        </ion-col>
                        <ion-col *ngIf="session.tickets_remaining" size="auto">
                            <h5>Tickets left</h5>
                            <p class="prominent">
                                <span *ngIf="session.tickets_remaining > session.low_ticket_threshold" class="success">{{session.tickets_remaining}}</span>
                                <span *ngIf="session.tickets_remaining <= session.low_ticket_threshold && session.tickets_remaining > 0" class="warning"></span>
                                <span *ngIf="session.tickets_remaining <= 0" class="danger">{{session.tickets_remaining}}</span>
                            </p>
                        </ion-col>
                    </ion-row>
                </ion-grid>
			</ion-label>
		</ion-item>
    </ion-list>

    <ion-grid *ngIf="sessions && sessions.length == 0" class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <p>
                    <fa-icon [icon]="['fal', 'calendar-day']" size="6x"></fa-icon>
                    <span>No sessions found</span>
                </p>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>